module.exports = __webpack_public_path__ + "img/jtupay-appstore.4b791043.png";